import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useApp } from '../context/AppContext';
import { CATEGORIES } from '../data/shayari';
import Logo from './Logo';

const WAIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" width="17" height="17">
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
  </svg>
);

const FBIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" width="17" height="17">
    <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
  </svg>
);


const TGIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" width="17" height="17">
    <path d="M11.944 0A12 12 0 000 12a12 12 0 0012 12 12 12 0 0012-12A12 12 0 0012 0a12 12 0 00-.056 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 01.171.325c.016.093.036.306.02.472-.18 1.898-.96 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.48.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.752-.245-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z"/>
  </svg>
);

const IGIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" width="17" height="17">
    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z"/>
  </svg>
);

const YTIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" width="17" height="17">
    <path d="M23.498 6.186a3.016 3.016 0 00-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 00.502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 002.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 002.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
  </svg>
);


const PLATFORMS = [
  { id: 'whatsapp',  label: 'WhatsApp',  color: '#25d366', Icon: WAIcon,  type: 'url',  url: (e) => `https://wa.me/?text=${e}` },
  { id: 'facebook',  label: 'Facebook',  color: '#1877f2', Icon: FBIcon,  type: 'url',  url: (e, u) => `https://www.facebook.com/sharer/sharer.php?u=${u}&quote=${e}` },
  { id: 'instagram', label: 'Instagram', color: '#e1306c', Icon: IGIcon,  type: 'copy', toast: '📸 Copied! Paste in your Instagram caption' },
  { id: 'youtube',   label: 'YouTube',   color: '#ff0000', Icon: YTIcon,  type: 'copy', toast: '▶️ Copied! Paste in YouTube description or community post' },
  { id: 'telegram',  label: 'Telegram',  color: '#2ca5e0', Icon: TGIcon,  type: 'url',  url: (e) => `https://t.me/share/url?text=${e}` },
];

const ShayariCard = ({ shayari, compact = false }) => {
  const { language, toggleFavorite, isFavorite, toggleLike, isLiked, showToast } = useApp();
  const [copied, setCopied]   = useState(false);
  const [likeAnim, setLikeAnim] = useState(false);
  const [showShare, setShowShare] = useState(false);

  const cat    = CATEGORIES.find(c => c.id === shayari.category);
  const text   = shayari[language] || shayari.en || shayari.hi;
  const author = shayari.author[language] || shayari.author.en;
  const isRtl  = language === 'ur';
  const liked  = isLiked(shayari.id);
  const fav    = isFavorite(shayari.id);

  const SITE = 'https://shayaristudio.online/';
  const shareText = `${text}\n\n— ${author}\n\n🌸 ${SITE}`;
  const encoded   = encodeURIComponent(shareText);

  const L = {
    copyMsg:    {hi:'📋 क्लिपबोर्ड पर कॉपी हुआ!',ur:'📋 کلپ بورڈ پر کاپی ہوئی!',en:'📋 Copied to clipboard!',es:'📋 ¡Copiado!',fr:'📋 Copié !'},
    copyFail:   {hi:'कॉपी विफल',ur:'کاپی ناکام',en:'Copy failed',es:'Error al copiar',fr:'Échec de la copie'},
    igMsg:      {hi:'📸 कॉपी हुआ! Instagram caption में पेस्ट करें',ur:'📸 کاپی ہوئی! Instagram کیپشن میں پیسٹ کریں',en:'📸 Copied! Paste in your Instagram caption',es:'📸 ¡Copiado! Pega en tu Instagram',fr:'📸 Copié ! Collez dans votre Instagram'},
    ytMsg:      {hi:'▶️ कॉपी हुआ! YouTube description में पेस्ट करें',ur:'▶️ کاپی ہوئی! YouTube میں پیسٹ کریں',en:'▶️ Copied! Paste in YouTube description',es:'▶️ ¡Copiado! Pega en YouTube',fr:'▶️ Copié ! Collez sur YouTube'},
    shareTitle: {hi:'यह शायरी शेयर करें',ur:'یہ شاعری شیئر کریں',en:'Share this shayari',es:'Compartir esta shayari',fr:'Partager cette shayari'},
    featured:   {hi:'⭐ चुनिंदा',ur:'⭐ منتخب',en:'⭐ Featured',es:'⭐ Destacado',fr:'⭐ À la une'},
  };
  const lang = language in L.copyMsg ? language : 'en';
  const copyMsg      = L.copyMsg[lang];
  const copyFail     = L.copyFail[lang];
  const igMsg        = L.igMsg[lang];
  const ytMsg        = L.ytMsg[lang];
  const shareTitle   = L.shareTitle[lang];
  const featuredLabel = L.featured[lang];

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(`${text}\n\n— ${author}\n\n🌸 ${SITE}`);
      setCopied(true);
      showToast(copyMsg);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      showToast(copyFail, 'error');
    }
  };

  const handleLike = () => {
    toggleLike(shayari.id);
    setLikeAnim(true);
    setTimeout(() => setLikeAnim(false), 600);
  };

  const handlePlatform = async (platform) => {
    if (platform.type === 'url') {
      const pageUrl = encodeURIComponent(window.location.href);
      window.open(platform.url(encoded, pageUrl), '_blank', 'noopener,noreferrer');
    } else {
      const toastMsg = platform.id === 'instagram' ? igMsg : ytMsg;
      try {
        await navigator.clipboard.writeText(`${text}\n\n— ${author}\n\n🌸 ${SITE}`);
        showToast(toastMsg);
      } catch {
        showToast(copyFail, 'error');
      }
    }
  };

  return (
    <article
      className={`shayari-card ${compact ? 'shayari-card--compact' : ''} ${shayari.featured ? 'shayari-card--featured' : ''}`}
      style={{ '--cat-color': cat?.color, '--cat-gradient': cat?.gradient }}
    >
      <div className="shayari-card__accent" />

      <div className="shayari-card__top">
        <Link to={`/category/${shayari.category}`} className="shayari-card__cat">
          <span>{cat?.icon}</span>
          <span>{cat?.label}</span>
        </Link>
        {shayari.featured && <span className="shayari-card__featured">{featuredLabel}</span>}
      </div>

      <div
        className={`shayari-card__text ${language === 'ur' ? 'urdu-text' : language === 'hi' ? 'hindi-text' : 'english-text'}`}
        dir={isRtl ? 'rtl' : 'ltr'}
      >
        <span className="shayari-card__open-quote">❝</span>
        {text.split('\n').map((line, i) => (
          <React.Fragment key={i}>
            {line}
            {i < text.split('\n').length - 1 && <br />}
          </React.Fragment>
        ))}
        <span className="shayari-card__close-quote">❞</span>
      </div>

      <div className="shayari-card__author">
        <span className="shayari-card__author-avatar">
          {author.charAt(0).toUpperCase()}
        </span>
        <span className="shayari-card__author-name">— {author}</span>
        <span style={{marginLeft:'auto',opacity:.25,pointerEvents:'none'}}>
          <Logo size="sm" variant="gold" />
        </span>
      </div>

      {!compact && shayari.tags && (
        <div className="shayari-card__tags">
          {shayari.tags.slice(0, 3).map(tag => (
            <span key={tag} className="shayari-card__tag">#{tag}</span>
          ))}
        </div>
      )}

      <div className="shayari-card__actions">
        <button
          className={`card-btn card-btn--like ${liked ? 'card-btn--liked' : ''} ${likeAnim ? 'card-btn--anim' : ''}`}
          onClick={handleLike}
          title="Like"
        >
          <span className="card-btn__icon">{liked ? '❤️' : '🤍'}</span>
          <span className="card-btn__count">{shayari.likes + (liked ? 1 : 0)}</span>
        </button>

        <button
          className={`card-btn card-btn--fav ${fav ? 'card-btn--fav-active' : ''}`}
          onClick={() => toggleFavorite(shayari.id)}
          title={fav ? 'Remove from favorites' : 'Add to favorites'}
        >
          <span className="card-btn__icon">{fav ? '🔖' : '📖'}</span>
        </button>

        <button
          className={`card-btn card-btn--copy ${copied ? 'card-btn--copied' : ''}`}
          onClick={handleCopy}
          title="Copy text"
        >
          <span className="card-btn__icon">{copied ? '✅' : '📋'}</span>
        </button>

        <button
          className={`card-btn card-btn--share ${showShare ? 'card-btn--share-open' : ''}`}
          onClick={() => setShowShare(s => !s)}
          title="Share on social media"
        >
          <span className="card-btn__icon">📤</span>
          <span className="card-btn__label">Share</span>
        </button>

        <div className="card-btn card-btn--views">
          <span className="card-btn__icon">👁️</span>
          <span className="card-btn__count">{shayari.views >= 1000 ? `${(shayari.views / 1000).toFixed(1)}k` : shayari.views}</span>
        </div>

        <Link to={`/shayari/${shayari.id}`} className="card-btn card-btn--permalink" title="View full page">
          <span className="card-btn__icon">🔗</span>
        </Link>
      </div>

      {showShare && (
        <div className="share-panel">
          <p className="share-panel__title">{shareTitle}</p>
          <div className="share-panel__grid">
            {PLATFORMS.map(({ id, label, color, Icon, ...rest }) => (
              <button
                key={id}
                className="share-social-btn"
                style={{ '--brand': color }}
                onClick={() => handlePlatform({ id, label, color, Icon, ...rest })}
                title={`Share on ${label}`}
              >
                <span className="share-social-btn__icon"><Icon /></span>
                <span className="share-social-btn__label">{label}</span>
              </button>
            ))}
          </div>
        </div>
      )}
    </article>
  );
};

export default ShayariCard;
